// i18n = {};
// @TODO Fix the dependency on i18n global variables, breaks unit tests - AM
var app = angular.module('jv.MyAccount', [
        'ngRoute',
        'ngSanitize',
        'jv',
        'jv.MyAccount.Breadcrumb.Ctrl',
        'jv.MyAccount.Navigation.Ctrl',
        'jv.MyAccount.Svc',
        'App.MyAccount.Ctrl',
        'App.MyAccount.Profile.Ctrl',
        'App.MyAccount.Preference.Ctrl',
        'App.MyAccount.Notifications.Ctrl',
        'jv.MyAccount.PersonalTemplates.Controller',
        'jv.MyAccount.EditPersonalTemplate.Controller',
        'jv.MyAccount.authApps.Ctrl',
        'jv.MyAccount.JobAlerts.Ctrl',
        //'jv.MyAccount.LiRsc.Ctrl',
        'jv.Common.Filters'
    ])
    .config(['$routeProvider',function($routeProvider){
        $routeProvider
            .when('/',{templateUrl:'profile2.html'})
            .when('/preferences',{templateUrl:'preferences.html'})
            .when('/notifications',{templateUrl:'notifications.html'})
            .when('/authorizedApps',{templateUrl:'authorizedApps.html'})
            .when('/authorizedApps/:fastRead',{templateUrl:'authorizedApps.html'})
            .when('/jobAlerts', {templateUrl:'jobAlerts.html'})
            //.when('/linkedInRecruiter', {templateUrl:'linkedInRecruiter.html'})
        .otherwise({redirectTo:'/'});
        if (!window.isJobSeeker && !window.hidePersonalTemplates) {
            $routeProvider
                .when('/emailTemplates',{templateUrl:'personalTemplates.html'})
                .when('/emailTemplates/:id',{templateUrl:'editPersonalTemplate.html'});
        }
    }])
    .value('Breadcrumbs', [{
            link: '#/profile',
            text: i18n['MYACCOUNT'],
            template: 'breadcrumbLink'
        }, {
            text: i18n['PROFILE'],
            template:'breadcrumb'
        }
    ])
    .value('Navigation', [{
            link: '#/profile',
            isCurrent: true,
            title: i18n['PROFILE']
        },{
            link: '#/preferences',
            isCurrent: false,
            title: i18n['PREFERENCES']
        },{
            link: '#/notifications',
            isHidden: window.hideNotifications,
            isCurrent: false,
            title: i18n['NOTIFICATIONS'
        ]},{
            link: '#/jobAlerts',
            isCurrent: false,
            title: i18n['JOB_ALERTS'
        ]},{
            link: '#/authorizedApps',
            isHidden: window.isJobSeeker,
            isCurrent: false,
            title: i18n['AUTHAPPS']
        }/*,{
            link: '#/linkedInRecruiter',
            isCurrent: false,
            title: i18n['LINKEDIN_RECRUITER']
        }*/,{
            //we need to hide this link for jobseekers
            link: window.jvUrls.source+'/account/jobPublish.html',
            isHidden: window.isJobSeeker,
            isCurrent: false,
            title: i18n['PUBLISHER']
        },{
            link: '#/emailTemplates',
            isHidden: window.isJobSeeker || window.hidePersonalTemplates,
            isCurrent: false,
            title: i18n['EMAIL_TEMPLATES']}
        ])
.config([
    '$controllerProvider',
    '$compileProvider',
    '$provide',
    '$filterProvider',
    function(
        $controllerProvider,
        $compileProvider,
        $provide,
        $filterProvider
    ) {
        app.controllerProvider = $controllerProvider;
        app.compileProvider = $compileProvider;
        app.controller = $controllerProvider.register;
        app.directive= $compileProvider.directive;
        app.filter= $filterProvider.register;
        app.factory= $provide.factory;
        app.service= $provide.service;
    }
]);